import { Component, OnInit, ViewChild, Inject, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AuthenticationService, MessageWindow, WindowModel } from '../authentication.Service';
import { MissionService } from "../MissionService";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subscription, timer } from "rxjs";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NameSurveyFromScratchComponent } from '../name-survey-from-scratch/name-survey-from-scratch.component';
import { SelectRespondentService } from '../select-respondents-landing-page/services/select-respondent.service';
import { JobMasterModel, SurveyService, Schedule } from '../survey.Service';
import { SurveyModel } from '../survey.Service';
import { SelectRespondentsLandingPageComponent } from '../select-respondents-landing-page/select-respondents-landing-page.component';
import { PanelPricingComponent } from '../edit-panel/panel-pricing/panel-pricing.component';
import { QuestionEditorComponent } from '../question-editor/question-editor.component';
import { InterviewModel } from '../question.service';
import { JoyrideService } from 'ngx-joyride';
import * as moment from 'moment-timezone';
import { version } from "../../environments/environment";
import { EstimateModel } from '../panel.Service';
import { WindowComponent } from '../Development/window-entry/window.component';
import { plainToClass } from 'class-transformer';
import { MatSelectChange } from '@angular/material/select';
import { TimezonePickerService } from '../scheduler/timezone-picker/timezone.service';
import { get } from 'http';
import { DatetimeAdapter } from '../scheduler/datetime-adapter';
import { TimezonePickerComponent } from '../scheduler/timezone-picker/timezone-picker.component';

@Component({
  selector: 'app-survey-details-navigation',
  templateUrl: './survey-details-navigation.component.html',
  styleUrls: ['./survey-details-navigation.component.css'],
  providers: [MissionService]
})
export class SurveyDetailsNavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  isLinear = true;
  surveyId: number = 0;
  messages = 0;

  surveyName: string = "";
  isExpanded = false;
  theme = "default";
  displayQRTiny: boolean = false;
  audienceSelected: boolean = false;
  displayScheduler = false;
  displaySendButton = false;
  scheduleType: string = "now";
  endDate: Date = new Date();
  currentVersion: string;
  currentYear = new Date().getFullYear();
  launch: boolean = false;
  launched: boolean = false;
  windows: WindowModel[]
  displayQuestionnaire: boolean = false;

  private inTimer = false;
  waiting?: Observable<any>;
  waitTime: Observable<any> = timer(0, 5000);
  subscription?: Subscription;
  displayStep2 = false;
  tz: number = 0;

  sendButtonText = '';

  @ViewChild('sidenav')
  public sidenav: any;

  @ViewChild('step1', { read: QuestionEditorComponent }) public step1: QuestionEditorComponent | undefined;
  @ViewChild('stepper') public stepper: MatStepper | undefined;
  @ViewChild('step2', { read: SelectRespondentsLandingPageComponent }) public step2: SelectRespondentsLandingPageComponent | undefined;
  @ViewChild('step3Pricing') public step3Pricing: PanelPricingComponent | undefined;
  @ViewChild('messageWindows') messageWindows: WindowComponent | undefined;

  firstFormGroup: FormGroup = new FormGroup({});
  secondFormGroup: FormGroup = new FormGroup({});
  timings: FormGroup = new FormGroup({});
  private _detect: boolean = true;

  constructor(private router: Router,
    private datetimeAdapter: DatetimeAdapter<Date>,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private overlayContainer: OverlayContainer,
    private breakpointObserver: BreakpointObserver,
    private auth: AuthenticationService,
    private actRoute: ActivatedRoute,
    private missionService: MissionService,
    private surveyService: SurveyService,
    private distributeService: SelectRespondentService,
    private readonly joyrideService: JoyrideService) {
    this.currentVersion = version;
    this.tz = moment.tz(TimezonePickerService.guess()).utcOffset();
    missionService.missionConfirmed$.subscribe(
      () => {
      });
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.timings = this._formBuilder.group({
      start: [new Date()],
      end: [new Date()]
    });
    this.timings.valueChanges.subscribe(result => {
      if (!this._detect) return;
      this._detect = false;
      this.schedules[0].start = this.adjustTime(this.timings.controls.start.value, this.tz);
      this.schedules[0].end = this.adjustTime(this.timings.controls.end.value, this.tz);
      this.schedules[0].cron = "0 0/2 * * * ? *";
      this.updateJobMaster(this.schedules[0]);
      this._detect = true;
    });
    this.surveyId = this.actRoute.snapshot.params.id;
    this.getSurveyDetails();
  }

  adjustTime(value: Date, offset: number) {
    let date = new Date(value);
    date.setMinutes(date.getMinutes() + offset);
    return date;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  isHandsetLandscape$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetLandscape)
    .pipe(map(result => result.matches));

  isHandsetPortrait$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
    .pipe(map(result => result.matches));

  ngOnInit(): void {

    this.overlayContainer.getContainerElement().classList.add(this.theme);
  }


  ngAfterViewInit(): void {
  }

  getSurveyDetails() {
    this.surveyService.getSurveyDetail(this.surveyId, true)
      .subscribe(result => {
        this.survey = SurveyModel.getSurveyObject(result);
        this.surveyName = result.Name;
        switch (this.survey.Channel) {
          case 3:
          case 4:
            break;
          default:
            this.displayQuestionnaire = true;
        }

        this.selectedScheduleType();
        if (this.scheduleType == "cron") {
          this.openScheduler();
        }
        else {
          this.selectNow();
        }

        this.windows = this.survey.Windows == null ? [] : this.survey.Windows;
      });
  }

  getChannelIcon() {

  }

  onWindowChange(value: WindowModel[]) {
    this.survey.Windows = value;
    this.surveyService.updateBasicDetails(this.survey).subscribe(
      result => {
        this.survey = SurveyModel.getSurveyObject(result);
        this.windows = this.survey.Windows ?? [];
      });
  }

  onTimeoutChange(selection: MatSelectChange) {
    this.survey.Occurences = selection.value;
    this.surveyService.updateBasicDetails(this.survey).subscribe(
      result => {
        this.survey = SurveyModel.getSurveyObject(result);
      });
  }

  onThemeChange() {
    this.overlayContainer.getContainerElement().classList.add(this.theme);
  }

  isAdmin() {
    return this.auth.isAuthorized(['Admin']);
  }

  isTester() {
    return this.auth.isAuthorized(['diy']);
  }

  gotoInbox() {
    this.router.navigate(['../inbox'])
  }

  openTerms() {
    const url = this.router.createUrlTree(['/termsofservice'])
    window.open(url.toString(), '_blank')
  }

  openPrivacy() {
    const url = this.router.createUrlTree(['/privacystatement'])
    window.open(url.toString(), '_blank')
  }

  panelPricingReady() {
    return this.step2 != undefined; // && this.step3Pricing != undefined;
  }

  get hasScript() {
    if (!this.survey) {
      return false;
    }
    return this.survey.QuestionCount > 0;
  }

  get hasPanel() {
    if (!this.survey) {
      return false;
    }
    return this.survey.PanelID > 0;
  }

  get survey(): SurveyModel {
    return this._survey;
  }
  set survey(value: SurveyModel) {
    this._survey = value;
  }
  private _survey: SurveyModel;

  toggleSideMenu() {
    this.sidenav.toggle();
  }
  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  goToHome() {
    this.surveyService.getSurveyCount()
      .subscribe(response => {
        if (response > 0) {
          this.router.navigate(['../surveydashboard/0']);
        } else {
          this.router.navigate(['../startfromtemplate']);
        }
      });
  }

  openBasicDialog(): void {
    const dialogRef = this.dialog.open(NameSurveyFromScratchComponent,
      {
        data: { id: this.surveyId }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.survey) {
          this.survey = SurveyModel.getSurveyObject(result);
          this.surveyName = this.survey.Name;
        }
      }
    });
  }

  timeIsValid(): boolean {
    if (this.survey.JobMaster == undefined || this.survey.JobMaster == null) {
      return false;
    }

    if (this.schedules == undefined || this.schedules.length == 0) {
      this.schedules = this.survey.JobMaster.Crons;
    }

    if (this.schedules[0].start == undefined || this.schedules[0].end == undefined) {
      return false;
    }

    if (this.datetimeAdapter.compareDateWithTime(new Date(), this.schedules[0].end) >= 0) {
      return false;
    }

    return this.schedules[0].start < this.schedules[0].end;
  }

  moveToThirdStep(stepper: MatStepper) {
    stepper.next();
  }

  selectNow(): void {
    this.displayScheduler = false;
    this.displaySendButton = true;
    this.sendButtonText = 'Send';
    this.checkJobMaster("", true);
  }

  selectedScheduleType() {
    if (this.survey.JobMaster) {
      if (this.survey.JobMaster.CronExpression === "") { // || this.survey.JobMaster.Name === "") {
        this.scheduleType = "now";
      }
      else {
        this.scheduleType = "cron";
      }
    }
  }

  get schedules(): Schedule[] | null {
    return this._schedules;
  }
  set schedules(value: Schedule[] | null) {
    this._schedules = value;
    if (this.survey.JobMaster == undefined || this.survey.JobMaster == null) {
      this.CreateNewJobMaster();
    }
  }
  private _schedules: Schedule[] | null = [new Schedule(TimezonePickerService.guess(), false, new Date(), new Date(new Date().getDate() + 3), "")];

  sendSurvey() {
    this.launch = true;
    this.launched = false;
    if (this.displaySendButton) {
      this.displaySendButton = false;
      if (this.step2 != undefined) {
        this.surveyService.makePayment(this.survey, this.step2.estimate ?? new EstimateModel()).subscribe(
          result => {
            this.surveyService.makeLive(this.survey).subscribe(
              result => {
                this.inTimer = false;
                this.subscription = this.waitTime.subscribe(() => {
                  if (this.inTimer) {
                    return;
                  }

                  this.inTimer = true;
                  this.surveyService.getSurveyDetail(this.survey.SurveyID, true).subscribe(
                    result => {
                      if (result.Status != 1 && result.Status != 3) {
                        this.launch = false;
                        this.launched = true;
                        this.router.navigate(["delivery-summary", this.survey.SurveyID, "summary"]);
                      }
                    });
                  this.inTimer = false;
                });
              });
          });
      }
    }
  }

  backtoDashboard() {
    this.subscription?.unsubscribe();
    this.router.navigate(['/surveydashboard']);
  }

  timezoneChanged(value: TimezonePickerComponent) {
    this.schedules[0].timezone = value.currentTimezone;
    let tzAdjustment = this.tz;
    this.tz = moment.tz(value.currentTimezone).utcOffset();
    tzAdjustment = this.tz - tzAdjustment;
    this.schedules[0].start = this.adjustTime(this.schedules[0].start, tzAdjustment);
    this.schedules[0].end = this.adjustTime(this.schedules[0].end, tzAdjustment);
    this.updateJobMaster(this.schedules[0]);
  }

  openScheduler(): void {
    this.displaySendButton = true;
    this.displayScheduler = true;
    this.sendButtonText = "Schedule";
    let temp = "";
    if (this.survey && this.survey.JobMaster) {
      if (this.survey.JobMaster.CronExpression == '') {
        this.survey.JobMaster.CronExpression = "0 0 1 1 *";
      }

      temp = this.survey.JobMaster.CronExpression;
    }

    this.checkJobMaster(temp, true);
  }

  get interview(): InterviewModel | null {
    return this.step1?.interview ?? new InterviewModel();
  }

  get timezone(): string {
    return TimezonePickerService.guess();
  }

  get jobMasterEnd(): Date {
    return this.adjustTime(this.survey.JobMaster.End, -this.tz); 
  }

  endChanged(value: Date) {
    this.survey.JobMaster.End = this.adjustTime(value, this.tz);
    if (this.schedules == undefined || this.schedules.length == 0) {
      this.schedules = this.survey.JobMaster.Crons;
    }

    this.schedules[0].end = this.survey.JobMaster.End;
    this.updateJobMaster(this.schedules[0]);
  }

  private CreateNewJobMaster() {
    this.survey.JobMaster = new JobMasterModel();
    this.survey.JobMaster.JobMasterId = 0;
    this.survey.JobMaster.SurveyID = this.survey.SurveyID;
    this.survey.JobMaster.Name = TimezonePickerService.guess();
    this.survey.JobMaster.Subject = "";
    this.survey.JobMaster.Content = "";
    this.survey.JobMaster.CanMissfire = false;
    this.survey.JobMaster.Adjustment = this.tz;
    this.survey.JobMaster.Start = this.adjustTime(new Date(), this.tz);
    this.survey.JobMaster.End = this.adjustTime(new Date(), this.tz);
    this.survey.JobMaster.CronExpression = "";
    this.survey.JobMaster.End.setDate(this.survey.JobMaster.End.getDate() + 3);
    if (this.survey.Channel == 1) {
      this.survey.JobMaster.ChannelID = 2; // SMS
    }
  }

  private checkJobMaster(cron: string, updateSchedule: boolean) {
    if (this.survey.JobMaster) {
      if (cron == "") {
        this.survey.JobMaster.Adjustment = this.tz;
        let tempDate = new Date(); //  this.adjustTime(new Date(), -this.tz);
        tempDate.setDate(tempDate.getDate() + 3);
        if (tempDate > this.adjustTime(this.survey.JobMaster.End, -this.tz)) {
          this.survey.JobMaster.End = this.adjustTime(tempDate, this.tz); //.setDate(this.survey.JobMaster.End.getDate() + 3);
        }

        this.survey.JobMaster.CronExpression = "";
        this._schedules = [];
      }
      else {
        let timezone = this.survey.JobMaster.Name;
        if (this.survey.JobMaster.Name.includes("|")) {
          timezone = this.survey.JobMaster.Name.split("|")[0];
        }

        let endDate = new Date(new Date().setDate(new Date().getDate() + 3));
        if (this.survey.JobMaster.End < endDate && this.survey.JobMaster.End < new Date()) {
          this._schedules = this.survey.JobMaster.Crons;
          this._schedules[0].start = this.survey.JobMaster.End = this.adjustTime(endDate, this.tz);

        }

        if (updateSchedule) {
          this._schedules = this.survey.JobMaster.Crons;
          if (this._schedules[0].timezone == '') {
            this._schedules[0].timezone = this.timezone;
            this.updateJobMaster(this._schedules[0]);
          }

          this._detect = false;
          this.timings.controls.start.setValue(this.adjustTime(this.survey.JobMaster.Start, -this.tz));
          this.timings.controls.end.setValue(this.adjustTime(this.survey.JobMaster.End, -this.tz));
          this._detect = true;
        }
      }

      return;
    }

    this.CreateNewJobMaster();
    this.surveyService.saveJobMaster(this.survey.JobMaster).subscribe();
  }

  updateJobMaster(schedule: Schedule) {
    if (this.survey.JobMaster == null) {
      this.survey.JobMaster.Launched = new Date();
      this.survey.JobMaster.JobTypeID = 1;
      if (this.survey.JobMaster.ChannelID == 0 && this.survey.Channel == 1) {
        this.survey.JobMaster.ChannelID = 2;
      }
    }

    let changed = false;
    if (this.survey.JobMaster.CronExpression != schedule.cron) {
      this.survey.JobMaster.CronExpression = schedule.cron;
      changed = true;
    }

    let start = schedule.start; // this.adjustTime(schedule.start, this.tz);
    if (this.survey.JobMaster.Start != start) {
      this.survey.JobMaster.Start = schedule.start;
      changed = true;
    }

    let end = schedule.end; // this.adjustTime(schedule.end, this.tz);
    if (this.survey.JobMaster.End != end) {
      this.survey.JobMaster.End = schedule.end;
      changed = true;
    }

    if (this.survey.JobMaster.Adjustment != schedule.offset) {
      this.survey.JobMaster.Adjustment = schedule.offset;
      changed = true;
    }

    if (this.survey.JobMaster.Name != schedule.timezone) {
      this.survey.JobMaster.Name = schedule.timezone;
      changed = true;
    }

    if (changed) {
      this.survey.JobMaster.updateCrons([schedule]);
      this.surveyService.saveJobMaster(this.survey.JobMaster).subscribe();
    }
  }
}
